export default __webpack_public_path__ + "static/media/mapping_icon.9234b513.svg";